import { jsx as o } from "react/jsx-runtime";
import a from "../../utils/classNames.js";
const l = ({ footer: r, className: e = "" }) => {
  if (!r)
    return null;
  const s = a("SidebarFooter", e);
  return /* @__PURE__ */ o("div", { className: s, children: r });
};
export {
  l as default
};
//# sourceMappingURL=SidebarFooter.js.map
